export default __webpack_public_path__ + "static/N0263-3881cb9839c6ea2122b519a0e8798fcf.png";